var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2344 11H6.23438C5.68209 11 5.23438 11.4477 5.23438 12V26C5.23438 26.5523 5.68209 27 6.23438 27H26.2344C26.7867 27 27.2344 26.5523 27.2344 26V12C27.2344 11.4477 26.7867 11 26.2344 11Z",
    stroke: "#EE7A30",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7344 11V6.5C11.7344 5.30653 12.2085 4.16193 13.0524 3.31802C13.8963 2.47411 15.0409 2 16.2344 2C17.4278 2 18.5724 2.47411 19.4164 3.31802C20.2603 4.16193 20.7344 5.30653 20.7344 6.5V11",
    stroke: "#EE7A30",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2344 20.5C17.0628 20.5 17.7344 19.8284 17.7344 19C17.7344 18.1716 17.0628 17.5 16.2344 17.5C15.4059 17.5 14.7344 18.1716 14.7344 19C14.7344 19.8284 15.4059 20.5 16.2344 20.5Z",
    fill: "#EE7A30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.9dccd2b9b38ca4458e5eafa80a34f8a9.svg";
export { ForwardRef as ReactComponent };